import { createAsyncThunk } from '@reduxjs/toolkit';
import { getReportExport } from '../../helpers/bff_helper';

export const getExportations = createAsyncThunk(
  'exportations/getExportations',
  async (params) => {
    const response = await getReportExport(params);

    const mappedData = response.data.map((item) => ({
      id: item.id,
      description: item.filename,
      status: item.status === 'done' ? 'Completed' : item.status === 'processing' ? 'Processing' : item.status === 'pending' ? 'Pending' : item.status === 'failed' ? 'Failed' : item.status,
      requestedAt: item.created_at,
      completedAt: item.status === 'done' ? item.created_at : null,
      fileUrl: item.file_url,
      totalRecords: item.lines_exported,
    }));

    return {
      data: mappedData,
      meta: {
        total: response.meta.total,
        page: response.meta.page,
        pageSize: response.meta.take,
        totalPages: response.meta.pages,
      },
    };
  }
);
